let config = {
  default: {
    partnerName: process.env.VUE_APP_PARTNER_NAME,
    i18n: {
      locale: process.env.VUE_APP_I18N_LOCALE,
      fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE
    },
    api: {
      basePath: "api"
    },
    customerSearchApi: {
      basePath: "api/lms"
    }
  },

  development: {
    api: {
      host: "http://localhost",
      port: 3001
    },
    customerSearchApi: {
      host: "http://localhost",
      port: 3000
    }
  },

  production: {
    api: {
      host: "https://connect.sasa.solutions"
    },
    customerSearchApi: {
      host: "https://beta.sasa.solutions"
    }
  }
};

if (process.env.NODE_ENV === "production") config = mergeWithDefaults(config.default, config.production);
else config = mergeWithDefaults(config.default, config.development);

// Define dynamic config values here.
config = prepareRuntimeConfig(config)
config = prepareApiConfig(config)

function prepareRuntimeConfig(config) {
  config["runtime"] = {
    version: require('../package.json').version,
    isProduction: process.env.NODE_ENV === "production",
    isDevelopment: process.env.NODE_ENV === "development",
    basePath: "/"
  }

  return config;
}

function prepareApiConfig(config) {
  config.api["baseUrl"] = buildApiBaseUrl(config.api);
  config.customerSearchApi["baseUrl"] = buildApiBaseUrl(config.customerSearchApi);
  return config;
}

function buildApiBaseUrl(api) {
  const port = api.hasOwnProperty('port') ? `:${api.port}/` : "/";
  return `${api.host}${port}${api.basePath}/`;
}

function mergeWithDefaults(defaults, config) {
  const result = { ...defaults };

  for (let key in config) {
    if (config[key] instanceof Object && defaults[key] instanceof Object) {
      result[key] = mergeWithDefaults(defaults[key], config[key]);
    } else {
      result[key] = config[key];
    }
  }

  return result;
}

const AppConfig = config;
Object.freeze(AppConfig);
module.exports = AppConfig;